import { SET_SOUNDOFF, LOADING_DATA, LIKE_SOUNDOFF, UNLIKE_SOUNDOFF, SET_SOUNDOFFS, LOADING_UI, STOP_LOADING_UI, DELETE_SOUNDOFF, POST_SOUNDOFF, CLEAR_ERRORS, SET_ERRORS, SUBMIT_COMMENT } from '../types';
import axios from 'axios';

export const getSoundOffs = () => dispatch => {
    dispatch({ type: LOADING_DATA });
    axios.get('/soundoffs').then((res) => {
        dispatch({
            type: SET_SOUNDOFFS,
            payload: res.data
        });
    }).catch((err) => {
        dispatch({ type: SET_SOUNDOFFS, payload: [] });
    })

}

export const getSoundOff = (soundOffId) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .get(`/soundoff/${soundOffId}`)
        .then((res) => {
            dispatch({
                type: SET_SOUNDOFF,
                payload: res.data
            });
            dispatch({ type: STOP_LOADING_UI });
            dispatch({ type: CLEAR_ERRORS });
        })
        .catch((err) => console.log(err));
};


export const postSoundOff = (newSoundOff) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .post('/soundoff', newSoundOff)
        .then((res) => {
            dispatch({
                type: POST_SOUNDOFF,
                payload: res.data.soundOff
            });
            dispatch(clearErrors());
        })
        .catch((err) => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            });
        });
};

//like soundoff
export const likeSoundOff = (soundOffId) => dispatch => {
    axios.get(`/soundoff/${soundOffId}/like`).then((res) => {
        dispatch({ type: LIKE_SOUNDOFF, payload: res.data })
    }).catch((err) => console.log(err))
}

//unlike soundoff
export const unLikeSoundOff = (soundOffId) => (dispatch) => {
    axios
        .get(`/soundoff/${soundOffId}/unlike`)
        .then((res) => {
            console.log(res.data)
            dispatch({
                type: UNLIKE_SOUNDOFF,
                payload: res.data
            });

        })
        .catch((err) => console.log(err));
};

//post a comment
export const submitComment = (soundOffId, commentData) => (dispatch) => {

    axios.post(`/soundoff/${soundOffId}/comment`, commentData).then((res) => {

        dispatch({ type: SUBMIT_COMMENT, payload: res.data });
        dispatch(clearErrors());

    }).catch((err) => {
        dispatch({ type: SET_ERRORS, payload: err.response.data });
    })
}
export const getUserData = (userHandle) => (dispatch) => {
    dispatch({ type: LOADING_DATA });
    axios
        .get(`/users/${userHandle}`)
        .then((res) => {
            console.log(res.data)
            dispatch({
                type: SET_SOUNDOFFS,
                payload: res.data.soundOffs
            });
        })
        .catch(() => {
            dispatch({
                type: SET_SOUNDOFFS,
                payload: null
            });
        });
};

export const deleteSoundOff = (soundOffId) => (dispatch) => {
    axios.delete(`/soundoff/${soundOffId}`).then(() => {
        dispatch({ type: DELETE_SOUNDOFF, payload: soundOffId });

    }).catch((err) => console.log(err))
}


export const clearErrors = () => (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
};